<template>
  <!-- <PreloaderPage /> -->
  <div class="regulation-page">
    <BannerPages
      :title="'AuthRegulation.banner.titlebanner'"
      :descriptions="[
        $t('AuthRegulation.banner.descriptbanner'),
      ]"
      alt="Tradeview regulatory oversight"
      :img="'/images/regulation/regulation-banner.png'"
    />

    <LazyRegionGlobal />

    <LazyMoreResource
      :titleH2="'AuthRegulation.protectedTitle'"
      :cards="cards"
      :padding="'padding-icon'"
      class="protected with-icons"
      :style="degrade"
    />
    <client-only>
      <LazyInvestment
        v-if="locale !== 'ja'"
        :label="'AuthRegulation.brokerage'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyRegionGlobal from "~/components/Regulation/RegionGlobal.vue";
import LazyMoreResource from "~/components/home/MoreResource";
// import PreloaderPage from "~/components/PreloaderPage.vue";

import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();

const nuxtImg = useImage();

const title = t("seo.regulation.title");
const description = t("seo.regulation.description");
const imgSeo = 'https://tradeview.eu/images/seo/09Authorizedandregulated.png'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/regulation/A&R-Gradient.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});


const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

let cards = ref([
  {
    icon: "sync",
    title: "forms_and_documents.protectedCardTitle1-1",
    desc: "forms_and_documents.protectedCardDesc1-1",
  },
  {
    icon: "account_balance_wallet",
    title: "forms_and_documents.protectedCardTitle2",
    desc: "forms_and_documents.protectedCardDesc2",
  },
  {
    icon: "lock",
    title: "forms_and_documents.protectedCardTitle3",
    desc: "forms_and_documents.protectedCardDesc3",
  },
  {
    icon: "acute",
    title: "forms_and_documents.protectedCardTitle4",
    desc: "forms_and_documents.protectedCardDesc4",
  },
]);
</script>